import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex';
import router from './router'
Vue.use(Vuex);
Vue.directive('loadmore', {
	bind(el, binding) {
		// 获取element-ui定义好的scroll盒子
		const SELECTWRAP_DOM = el.querySelector('.ivu-select-dropdown')
		SELECTWRAP_DOM.addEventListener('scroll', function () {
			const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
			if (CONDITION) {
				binding.value()
			}
		})
	}
})
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
var options = {
	fullscreenEl: false //关闭全屏按钮
}
Vue.use(preview, options)

import axios from 'axios';
Vue.prototype.$http = axios;
// import wx from 'weixin-js-sdk'
// Vue.prototype.$wx = wx;
// Vue.use(wx)
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import stringUtils from "./assets/js/stringUtil.js";

Vue.config.productionTip = false
import './assets/css/style.css'
import './assets/iconfont/iconfont.css'

import httpUrl from "./api/httpUrl";
Vue.prototype.$httpUrl = httpUrl;

import configure from "./api/configure";
Vue.prototype.$configure = configure;

import stringUtil from './assets/js/stringUtil.js';
Vue.prototype.stringUtil = stringUtil;

import {
	Message
} from 'element-ui'
Vue.prototype.Message = Message;

import {
	getLoginUserInfo
} from '@/utils/auth'
Vue.prototype.getLoginUserInfo = getLoginUserInfo

import {
	assignControl,
	submitValidate,
	convertInTable,
	assignControlBySpNo
} from '@/utils/controls'
Vue.prototype.assignControl = assignControl
Vue.prototype.submitValidate = submitValidate
Vue.prototype.convertInTable = convertInTable
Vue.prototype.assignControlBySpNo = assignControlBySpNo

import {
	getCondtion, getCondtionByLevel, getSuperiorIsMatchDepth, getRelationList, findEmpByPositionName,
	getDepartmentRelation,
	findEmpByLevel,
	getDepartmentRelationList
} from '@/utils/processcondtion'
Vue.prototype.getCondtion = getCondtion
Vue.prototype.getCondtionByLevel = getCondtionByLevel
Vue.prototype.getSuperiorIsMatchDepth = getSuperiorIsMatchDepth
Vue.prototype.getRelationList = getRelationList
Vue.prototype.findEmpByPositionName = findEmpByPositionName
Vue.prototype.getDepartmentRelation = getDepartmentRelation
Vue.prototype.findEmpByLevel = findEmpByLevel
Vue.prototype.getDepartmentRelationList = getDepartmentRelationList


import {
	tableOperation,
	guid
} from '@/utils/tableDelete'
Vue.prototype.tableoperation = tableOperation
Vue.prototype.guid = guid


//引入组件
import './utils/common.js'

//定义全局变量
var store = new Vuex.Store({
	state: {
		login: false,
		defaultMember: ["SC24000029", "钟志斌"],
		//有很多都是直接在页面中的判断的，现在慢慢的 集中放到一起
		// type说明：
		// values：统一使用二维数组，格式与逐级审批控件 Values 一致，如 [["SC12120055", "刘晴"]]。
		// replace：接口返回了已离职人员时，把 replace_emp_no 替换成 values[0]。
		// append：接口正常返回后，固定追加 values 中的指定审批人。
		// insert_before：接口返回 replace_name/replace_emp_no 时，在该人员前插入 values 中的指定审批人。
		// fallback：只有接口未取到审批人(values为空)时，按部门名称关键词判断后补上 values。
		// page_names：规则适用页面，新增规则时必须标记页面，避免不同流程互相影响。
		zhujishenpi: [
			// 接口未取到审批人(values为空)时才补：藤云部门补刘晴、徐菁。
			{
				"type": "fallback",
				"page_names": ["FirstHandEarlyWarningCheck", "FirstHandEarlyWarningCheckForNew", "FirstHandEarlyWarningCheckForNew2", "OtherApplySignApprove"],
				"replace_name": "", "values": [["SC12120055", "刘晴"], ["SC03080007", "徐菁"]], "department_keywords": ["华西区/藤云"]
			},

			// 接口未取到审批人(values为空)时才补：根据申请人部门路径 fullName 截取关键词判断；包含原秦文、程科离职临时处理。
			{
				"type": "fallback",
				"page_names": ["FirstHandEarlyWarning", "FirstHandEarlyWarningCheckForNew", "SalaryManager", "AdministrativeProcurementApplication","OtherApplySignApprove"],
				"replace_name": "", "values": [["SC23000441", "陈相云"]], "department_keywords": ["营业部/二级市场营运中心", "非营业部/二级市场支援中心", "华西区/代理/项目营运"]
			},
		],
		secondaryCommissionAuth: {
			// 李雨 SC16005868  罗颖SC24000317 李立SC24000035
			// SecondaryCommission.vue 新建申请权限白名单
			commission: {
				create: ["SC12050030", "SC16005075", "SC17001763", "SC22001092", "SC22000584", "SC20003197", "SC22001262","SC16005868","SC24000317","SC24000035"]
			},
			// SecondaryCommissionA.vue 申请权限白名单
			commissionA: {
				apply: ["SC09110035", "SC12050030", "SC16005075", "SC17001763", "SC18002633", "SC19004201", "SC22000584", "SC22001262","SC16005868","SC24000317","SC24000035"]
			},
			// SecondaryCommissionB.vue 申请权限白名单
			commissionB: {
				apply: ["SC09110035", "SC12050030", "SC16005075", "SC17001763", "SC18002633", "SC22001262","SC16005868","SC24000317","SC24000035"]
			}
		},
		clickDelete: false,
		clickDeleteSum: 0
	},
	mutations: {
		alteration(state, val) {
			state.clickDelete = val;
		},
		reduce(state) {
			state.clickDeleteSum--;
		},
		alterationSum(state, val) {
			state.clickDeleteSum = val;
		}
	},
	actions: {
		SetAlteration({ commit }, val) {
			commit('alteration', val)
		},
		RmReduce({ commit }) {
			commit('reduce')
		},
		SetAlterationSum({ commit }, val) {
			commit('alterationSum', val)
		}
	}
})

function hasZhujishenpiMember(values, empNo) {
	return Array.isArray(values) && values.some(item => Array.isArray(item) && item[0] === empNo);
}

function getZhujishenpiMembers(config) {
	return Array.isArray(config.values) ? config.values.filter(item => Array.isArray(item) && item.length >= 2) : [];
}

function appendZhujishenpiMembers(values, members) {
	members.forEach(member => {
		if (!hasZhujishenpiMember(values, member[0])) {
			values.push(member);
		}
	});
}

Vue.prototype.applyZhujishenpiValues = function (values, pageName, options) {
	options = options || {};
	if (!Array.isArray(values)) {
		values = [];
	}
	const configs = (this.$store && this.$store.state.zhujishenpi) || [];
	configs.forEach(config => {
		if (Array.isArray(config.page_names) && config.page_names.indexOf(pageName) === -1) {
			return;
		}
		const members = getZhujishenpiMembers(config);
		// append：接口已有审批人时也固定追加，用于页面要求指定人员审批的场景。
		if (config.type === "append") {
			appendZhujishenpiMembers(values, members);
		}
		// insert_before：接口返回指定人员时，插入到该人员前面，不存在则不处理。
		if (config.type === "insert_before") {
			const index = values.findIndex(item => Array.isArray(item) && (item[0] === config.replace_emp_no || item[1] === config.replace_name));
			if (index !== -1) {
				const insertMembers = members.filter(member => !hasZhujishenpiMember(values, member[0]));
				values.splice(index, 0, ...insertMembers);
			}
		}
		// fallback：只有接口没有取到审批人(values为空)时，按部门路径关键词补人。
		if (config.type === "fallback" && values.length <= 0) {
			const fullName = options.fullName || "";
			const keywords = config.department_keywords || [];
			if (keywords.some(keyword => fullName.indexOf(keyword) > -1)) {
				appendZhujishenpiMembers(values, members);
			}
		}
	});
	return values;
}

Vue.prototype.getZhujishenpiReplaceData = function (pageName) {
	const configs = (this.$store && this.$store.state.zhujishenpi) || [];
	return configs
		.filter(config => config.type === "replace" && Array.isArray(config.values))
		.filter(config => !Array.isArray(config.page_names) || config.page_names.indexOf(pageName) !== -1)
		.filter(config => getZhujishenpiMembers(config).length > 0)
		.map(config => {
			const members = getZhujishenpiMembers(config);
			return {
				old: config.replace_emp_no,
				new: members[0][0],
				name: members[0][1]
			}
		})
		.filter(config => config.new && config.name);
}

function setCookie(key, value, t) {
	var oDate = new Date();
	oDate.setDate(oDate.getDate() + t);
	document.cookie = key + "=" + value + "; expires=" + oDate.toDateString();
}

function GetQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
	var context = "";
	if (r != null)
		context = r[2];
	reg = null;
	r = null;
	return context == null || context == "" || context == "undefined" ? "" : context;
}

// import VConsole from 'vconsole'

// Vue.prototype.$vConsole = new VConsole();

//路由守卫
router.beforeEach((to, from, next) => {
	// next();

	document.title = to.meta.title;
	if (to.meta.isLogin && store.state.login) {
		next();
	} else if (to.meta.isLogin && !store.state.login) {
		var logInfo = getLoginUserInfo();
		var code = GetQueryString("code");

		if (logInfo != null && logInfo != '') {
			var data = stringUtils.getCookies("logInfo");
			if (data == null) {
				if (logInfo != null) {
					localStorage.setItem('logInfo', null);
					logInfo = null;
					location.href = "https://cdsso.centaline.com.cn/sso/sso-loginout/loginout?clienttype=qy&appid=be460f78-9d38-4644-ae7e-817185819291&redirect_uri=" +
						encodeURIComponent(window.location.href);
					return;
				}
			}
			next(this);
			return;
		}
		//单点登录
		if (code != null && code != '') {
			Vue.prototype.$http({
				url: Vue.prototype.$httpUrl.getuserinfo + "?code=" + code,
				method: "get",
			}).then(res => {
				if (res.data == null || res.data == '' || res.data.Body.EmployeeInfo == null || res.data.Body.EmployeeInfo.EmpNo == null || res.data.Body.EmployeeInfo.EmpNo == '') {
					location.href =
						"https://cdsso.centaline.com.cn/sso/sso-oauth/authorize?clienttype=qy&appid=be460f78-9d38-4644-ae7e-817185819291&redirect_uri=" +
						encodeURIComponent(window.location.href);
					return;
				}
				let time = new Date().getTime() + 86400000;
				res.data.Body.EmployeeInfo.timestamp = time;
				setCookie("logInfo", JSON.stringify(res.data.Body.EmployeeInfo), 1);
				localStorage.setItem('logInfo', JSON.stringify(res.data.Body.EmployeeInfo));
				if (to.path == '/clear' && store.state.login == false) {
					next('/index');
				} else {
					next(this);
				}
				store.state.login = true;
			}, err => {
				console.log(err)
			});
		} else {
			location.href =
				"https://cdsso.centaline.com.cn/sso/sso-oauth/authorize?clienttype=qy&appid=be460f78-9d38-4644-ae7e-817185819291&redirect_uri=" +
				encodeURIComponent(window.location.href);
		}
	} else {
		next()
	}
})


new Vue({
	render: h => h(App),
	store,
	router
}).$mount('#app')
